import { toFixed } from 'accounting-js';
import { PAGE_TYPES } from '../enums/page-types';
import STRIPE_PAYMENT_METHODS from '../enums/stripe-payment-methods';

/**
 * Get the fees for the cart
 * @param {Array} fees
 * @param {number} amount
 * @returns {Array} [{
 *  amount: number,
 *  name: string,
 * }]
 */
export default function getFees({
  fees,
  amount,
  pageType,
  numberOfTickets,
  quantity,
  paymentMethod = '',
}) {
  if (!fees || !fees.length) {
    return null;
  }

  return fees
    .filter(fee => {
      // always apply if it's not limited to specific payment methods
      if (!fee.applyToSpecificPaymentMethods || !fee.paymentMethods?.length) return true;

      // apply if the fee should be applied for the given payment method
      if (fee.paymentMethods.includes(paymentMethod)) {
        return true;
      }

      if (
        paymentMethod === 'apple_pay' &&
        fee.paymentMethods.includes(STRIPE_PAYMENT_METHODS.CARD)
      ) {
        return true;
      }

      if (
        paymentMethod === 'google_pay' &&
        fee.paymentMethods.includes(STRIPE_PAYMENT_METHODS.CARD)
      ) {
        return true;
      }

      // don't apply fee
      return false;
    })
    .map(fee => {
      if (fee.percentage) {
        return {
          name: fee.name,
          amount: Number(toFixed((fee.percentage / 100) * amount, 0)),
          percentage: fee.percentage,
        };
      }

      if (pageType === PAGE_TYPES.CHECKOUT && fee.multiplyByQuantity) {
        return {
          name: fee.name,
          amount: Number(toFixed(fee.amount * quantity, 0)),
          percentage: null,
        };
      }

      if (pageType === PAGE_TYPES.EVENT && fee.multiplyByTickets) {
        return {
          name: fee.name,
          amount: Number(toFixed(fee.amount * numberOfTickets, 0)),
          percentage: null,
        };
      }

      return {
        name: fee.name,
        amount: Number(toFixed(fee.amount, 0)),
        percentage: null,
      };
    });
}
